import React from 'react';
import moment from 'moment';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

const AYearPicker = ({
  value = '',
  handler = () => {},
  minDate = moment('1950-01-01'),
  maxDate = moment().add(78, 'years'),
  width = 'auto',
  label = '',
}) => {
  const convertedValue = value ? moment(value, 'YYYY') : null;
  return (
    <LocalizationProvider dateAdapter={AdapterMoment}>
      <DatePicker
        label={label}
        value={convertedValue}
        onChange={(val) => {
          if (val) {
            handler(null, val.format('YYYY'), 'YEAR');
          } else {
            handler(null, '', 'YEAR');
          }
        }}
        openTo="year"
        views={['year']}
        minDate={minDate}
        maxDate={maxDate}
        yearsOrder="desc"
        sx={{
          width,
          '& .MuiInputBase-input': {
            fontSize: '11px',
            height: '1px',
            padding: '14px 0px 14px 14px'
          },
        }}
      />
    </LocalizationProvider>
  );
};

export default AYearPicker;
